import { useEffect, useState } from 'react'

type Delay = number

type ShowActiveParams = {
  delay?: Delay
  isOpen: boolean
}

type HandleOpenParams = {
  delay?: Delay
  setIsShowActive: (value: boolean) => void
}

// закрытие ассистента
const handleClose = (setIsShowActive: (value: boolean) => void) => {
  setIsShowActive(false)
}

// открытие ассистента
const handleOpen = ({ delay = 0, setIsShowActive }: HandleOpenParams) => {
  const timer = setTimeout(() => setIsShowActive(true), delay)
  return () => clearTimeout(timer)
}

/**
 * @function useShowActive - анимация активного состояния ассистента
 * @param delay - возможна задержка для анимации (ms)
 * @param isOpen - true - виджет открыт, false - виджет закрыт
 * @returns [isShowActive, setIsShowActive] - состояние и функция установки состояния
 */
const useShowActive = ({ delay = 0, isOpen }: ShowActiveParams) => {
  const [isShowActive, setIsShowActive] = useState(false)

  useEffect(() => {
    if (!isOpen) {
      handleClose(setIsShowActive)
      return
    }

    return handleOpen({ delay, setIsShowActive })
  }, [isOpen, delay])

  return [isShowActive, setIsShowActive] as const
}

export default useShowActive
